import { AnvandareDTO } from "~app/common/models/anvandare/AnvandareDTO";

export enum AttesteringStatus {
    Skapad = "Skapad",
    Skickad = "Skickad",
    Avvisad = "Avvisad",
    Godkand = "Godkänd"
}

export enum Betalningsmetod {
    Bankkonto = "Konto",
    Bankgiro = "Bankgiro",
    Postgiro = "Postgiro",
}
export class KontaktDTO implements IKontaktDTO {
    id: number;
    guid: string;
    kontaktLimeId: string;
    kontaktNamn: string;
    kontaktSkyddadIdentitet: boolean;
    kontaktpersonFornamn: string;
    kontaktpersonEfternamn: string;
    kontaktTelefon: string;
    kontaktKontaktMobiltelefon: string;
    kontaktKontaktEpost: string;
    kontaktAdress: string;
    kontaktAdress2: string;
    kontaktPostnummer: string;
    kontaktPostort: string;
    kontaktLand: string;
    kontaktOrgnummer: string;
    momsregistreringsnummer: string;
    momsnummerValideringsstatus?: string;
    momsnummerValideringstid?: string;
    momsnummerKontrollerat: string;
    momskod: string;
    betalningsmetod?: Betalningsmetod;
    bankgiro?: string;
    postgiro?: string;
    bankkonto?: string;
    clearingnummer?: string;
    bicSwift?: string;
    iban?: string;
    gln?: string;
    callbackNotering?: string;
    attesterasAv?: AnvandareDTO;
    godkandAv?: AnvandareDTO;
    attesteringStatus?: AttesteringStatus;
    createBetalningsinformationUtkast?: boolean;
    gruppering: string;
    klassning: string;
    utbo: string;
    villHaAlmanackan: boolean;
    avstarForum: boolean;
    ansvarigVirkeskopare: AnvandareDTO;
    kontaktReceiveDateTime: string;
    typAvKontakt: string;
    huvudkodInternnummerViol3: string;
    position3Intnr?: number;
    momsnummerEjAktuellt: boolean;
    momsnummerEjAktuelltAnsvarig: AnvandareDTO;
    momsnummerEjAktuelltTidpunkt: string;
    rowVersion: string;
    anskaffningsform: string;
    integrationExternOrganisation: string;
    integrationAnsvarigVirkeskopare: AnvandareDTO;
    integrationPrislistaId?: number;
    integrationPEFCCertifikatId?: number;
    integrationFSCCertifikatId?: number;
    externOrganisationer: IExternOrganisation[];

    constructor() {
        this.id = undefined;
        this.guid = undefined;
        this.kontaktLimeId = undefined;
        this.kontaktNamn = undefined;
        this.kontaktSkyddadIdentitet = undefined;
        this.kontaktpersonFornamn = undefined;
        this.kontaktpersonEfternamn = undefined;
        this.kontaktTelefon = undefined;
        this.kontaktKontaktMobiltelefon = undefined;
        this.kontaktKontaktEpost = undefined;
        this.kontaktAdress = undefined;
        this.kontaktAdress2 = undefined;
        this.kontaktPostnummer = undefined;
        this.kontaktPostort = undefined;
        this.kontaktLand = undefined;
        this.kontaktOrgnummer = undefined;
        this.momsregistreringsnummer = undefined;
        this.momsnummerValideringsstatus = undefined;
        this.momsnummerValideringstid = undefined;
        this.momsnummerKontrollerat = undefined;
        this.momskod = undefined;
        this.betalningsmetod = undefined;
        this.bankgiro = undefined;
        this.postgiro = undefined;
        this.bankkonto = undefined;
        this.clearingnummer = undefined;
        this.bicSwift = undefined;
        this.iban = undefined;
        this.gln = undefined;
        this.gruppering = undefined;
        this.klassning = undefined;
        this.utbo = undefined;
        this.villHaAlmanackan = undefined;
        this.avstarForum = undefined;
        this.ansvarigVirkeskopare = undefined;
        this.kontaktReceiveDateTime = undefined;
        this.typAvKontakt = undefined;
        this.huvudkodInternnummerViol3 = undefined;
        this.position3Intnr = undefined;
        this.momsnummerEjAktuellt = undefined;
        this.momsnummerEjAktuelltAnsvarig = undefined;
        this.momsnummerEjAktuelltTidpunkt = undefined;
        this.rowVersion = undefined;
        this.anskaffningsform = undefined;
        this.integrationExternOrganisation = undefined;
        this.integrationAnsvarigVirkeskopare = undefined;
        this.integrationPrislistaId = undefined;
        this.integrationPEFCCertifikatId = undefined;
        this.integrationFSCCertifikatId = undefined;
        this.externOrganisationer = undefined;
    }
}

export interface IKontaktDTO {
    id: number;
    guid: string;
    kontaktLimeId: string;
    kontaktNamn: string;
    kontaktSkyddadIdentitet: boolean;
    kontaktpersonFornamn: string;
    kontaktpersonEfternamn: string;
    kontaktTelefon: string;
    kontaktKontaktMobiltelefon: string;
    kontaktKontaktEpost: string;
    kontaktAdress: string;
    kontaktAdress2: string;
    kontaktPostnummer: string;
    kontaktPostort: string;
    kontaktLand: string;
    kontaktOrgnummer: string;
    momsregistreringsnummer: string;
    momsnummerValideringsstatus?: string;
    momsnummerValideringstid?: string;
    momsnummerKontrollerat: string;
    momskod: string;
    betalningsmetod?: Betalningsmetod;
    bankgiro?: string;
    postgiro?: string;
    bankkonto?: string;
    clearingnummer?: string;
    bicSwift?: string;
    iban?: string;
    gln?: string;
    callbackNotering?: string;
    attesterasAv?: AnvandareDTO;
    godkandAv?: AnvandareDTO;
    attesteringStatus?: AttesteringStatus;
    createBetalningsinformationUtkast?: boolean;
    gruppering: string;
    klassning: string;
    utbo: string;
    villHaAlmanackan: boolean;
    avstarForum: boolean;
    ansvarigVirkeskopare: AnvandareDTO;
    kontaktReceiveDateTime: string;
    typAvKontakt: string;
    huvudkodInternnummerViol3: string;
    position3Intnr?: number;
    momsnummerEjAktuellt: boolean;
    rowVersion: string;
    anskaffningsform: string;
    integrationExternOrganisation: string;
    integrationAnsvarigVirkeskopare: AnvandareDTO;
    integrationPrislistaId?: number;
    integrationPEFCCertifikatId?: number;
    integrationFSCCertifikatId?: number;
    externOrganisationer: IExternOrganisation[];
}
export interface IViesValidation {
    momsnummerValideringsstatus: string;
    momsnummerValideringstid: string;
    momsnummerKontrollerat: string;
}

export interface IExternOrganisation {
    namn: string;
    externKod: string;
    aktiv: boolean;
    hasVirkeskopskontrakt?: boolean;
}
